<sim-basic-material-dialog
	(closeClicked)="close({action: 'cancel'})"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-chart-column', fontSet: 'fad'}"
	[headerText]="T.EXAM_ARCHIVE_CHARTS_DIALOG_TITLE | translate"
	[matDialogData]="data"
	[rect]="rect"
	[smallHeader]="true"
	[overflowHandledByChild]="true"
>
	<ng-container dialogContent>
		<div class="contentCon">
			<div class="metadataCon">
				<label>
					<mat-icon fontIcon="fa-rectangles-mixed" fontSet="fad" inline />
					<span class="stationBubble"> {{ data.stationIndex }} </span>
					{{ T.LABEL_STATION | translate }}
				</label>
				<label>
					<mat-icon fontIcon="fa-note-medical" fontSet="fad" inline />
					{{ data.scenarioName }}
				</label>
				<label [class.inactive]="!data.examinerName">
					<mat-icon fontIcon="fa-user-md" fontSet="fad" inline />
					{{ data.examinerName ?? T.SHARED_EVENT_SESSION_NOT_SET | translate }}
				</label>
				<label>
					<mat-icon fontIcon="fa-user-graduate" fontSet="fad" inline />
					{{ data.studentName }}
				</label>
			</div>

			<mat-form-field>
				<mat-label>{{ T.LABEL_ASSESSMENT | translate }}</mat-label>
				<mat-select [formControl]="assessmentControl">
					@for (assessment of data.assessments; track assessment.id) {
						<mat-option [value]="assessment">
							{{ assessment.name }}
						</mat-option>
					}
				</mat-select>
			</mat-form-field>

			<mat-divider />

			<div class="chartCon">
				<canvas baseChart [data]="chartData()" [options]="chartOptions()" type="radar"></canvas>
			</div>

			<div class="scoreSummaryTitle">{{ T.EXAM_ARCHIVE_SCORE_SUMMARY | translate }}</div>
			<div class="scoreCon">
				<div class="labeledIconCon">
					<div class="iconCon"><mat-icon fontIcon="fa-star-half" fontSet="fad" inline /></div>
					<div class="labelCon">
						<span class="label">{{ T.EXAM_ARCHIVE_SCORE | translate }}</span>
						<span class="value">{{ reachedScore() }} ({{ reachedScorePercentage() | percent }})</span>
					</div>
				</div>
				<div class="labeledIconCon">
					<div class="iconCon"><mat-icon fontIcon="fa-star" fontSet="fad" inline /></div>
					<div class="labelCon">
						<span class="label">{{ T.EXAM_ARCHIVE_MAX_SCORE | translate }}</span>
						<span class="value">{{ maxScore() }}</span>
					</div>
				</div>
				<div class="labeledIconCon">
					<div class="iconCon"><mat-icon fontIcon="fa-ranking-star" fontSet="fad" inline /></div>
					<div class="labelCon">
						<span class="label">{{ T.EXAM_ARCHIVE_RESULT | translate }}</span>
						<span class="value">
							{{ state().state | enumLabel: EnumLabel.AssessmentState }}
							@if (!state().isFinal) {
								*
							}
						</span>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
</sim-basic-material-dialog>
